import { useEffect, useState } from "react";
import { type Doc, type Snapshot } from "sharedb/lib/client";

import { WorksheetType } from "../../shared/types/worksheet";

import { logInfoWithDebugFlag, rollbarAndLogError } from "utils/logger";
import { Worksheet } from "worksheets/views/Worksheet";

export const SubmissionWorksheet = ({
  doc,
  worksheetVersionNumber,
}: {
  doc: Doc<WorksheetType>;
  worksheetVersionNumber: number | null;
}) => {
  const [snapshot, setSnapshot] = useState<Snapshot<WorksheetType> | null>(null);

  useEffect(() => {
    doc.connection.fetchSnapshot(
      doc.collection,
      doc.id,
      worksheetVersionNumber,
      (error, fetchedSnapshot) => {
        if (fetchedSnapshot) {
          setSnapshot(fetchedSnapshot);
        }
        if (error) {
          // NOTE: developers, if you're seeing this error in your local environment, particularly if the associated
          // error code is ERR_OP_VERSION_NEWER_THAN_CURRENT_SNAPSHOT, it usually means that mongodb doesn't contain
          // a complete history of all ShareDB ops. Try doing a full mongodb restore using one of these commands:
          // >>> manage.py restore_mongo --latest development --full
          // or
          // >>> docker compose run --rm monarch-server-restore-databases-with-full-mongo --latest development
          const message =
            `SubmissionWorksheet: error fetching snapshot with collection=${doc.collection}, id=${doc.id}, ` +
            `version=${worksheetVersionNumber}`;
          rollbarAndLogError(message, error);
        }
      },
    );
  }, [worksheetVersionNumber, doc]);

  if (!snapshot) return null; // TODO: Replace with a better loading indicator.

  const skeletonDocWithHistoricData = {
    submitOp: (...args) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      logInfoWithDebugFlag("debug_sharedb", "Skipping submitOp in submission view:", ...args);
    },
    data: snapshot.data,
    on: () => {},
    presence: { create: () => {}, on: () => {}, off: () => {} },
    removeListener: () => {},
  } as unknown as Doc<WorksheetType>;

  return (
    <div>
      <Worksheet doc={skeletonDocWithHistoricData} />
    </div>
  );
};
